import { roundToDecimals } from '@prophecy/utils/number';

import { USAGE_AND_BILLING_PAGE } from '../constants';

/**
 * Converts the price to equivalent credits
 * @param price - The price to convert to credits
 * @param pricePerCredit - The price per credit
 * @returns The equivalent credits
 */
export const convertUSDToCredits = (price: number, pricePerCredit: number) => {
  return roundToDecimals(price / pricePerCredit);
};

/**
 * Converts the credits to equivalent USD
 * @param credits - The credits to convert to USD
 * @param pricePerCredit - The price per credit
 * @returns The equivalent price in dollars
 */
export const convertCreditsToUSD = (credits: number, pricePerCredit: number) => {
  return roundToDecimals(credits * pricePerCredit);
};

export const isUsageAndBillingPage = (pathname: string) => {
  return pathname.endsWith(USAGE_AND_BILLING_PAGE);
};
